import { useEffect, useRef } from 'react';

export function useIdleLogout({
	onLogout,
	idleMinutes = 15,
}: {
	onLogout: () => Promise<void>;
	idleMinutes?: number;
}) {
	const timeoutRef = useRef<NodeJS.Timeout | null>(null);

	const resetTimer = () => {
		if (timeoutRef.current) clearTimeout(timeoutRef.current);

		timeoutRef.current = setTimeout(async () => {
			// console.log('User inactive — logging out');
			await onLogout();
			// notify other tabs
			localStorage.setItem('user-logged-out', Date.now().toString());
		}, idleMinutes * 60 * 1000);
	};

	useEffect(() => {
		const activityEvents = [
			'mousemove',
			'mousedown',
			'keydown',
			'touchstart',
			'scroll',
		];

		const handleActivity = () => resetTimer();

		activityEvents.forEach((event) =>
			window.addEventListener(event, handleActivity),
		);

		// Initial timer
		resetTimer();

		return () => {
			activityEvents.forEach((event) =>
				window.removeEventListener(event, handleActivity),
			);
			if (timeoutRef.current) clearTimeout(timeoutRef.current);
		};
	}, [idleMinutes, onLogout]);

	// logout if another tab logs out
	useEffect(() => {
		const handler = () => {
			// console.log('Detected logout in another tab');
			onLogout();
		};

		window.addEventListener('storage', handler);
		return () => window.removeEventListener('storage', handler);
	}, [onLogout]);
}
